// Customer session persistence (mirrors the CALL_REQUEST localStorage pattern).
// Shape: { accessToken, refreshToken, customer }
const STORAGE_KEY = 'CUSTOMER_SESSION';

export const getCustomerSession = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        return null;
    }
};

export const saveCustomerSession = (session) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    } catch (err) {
        console.log(err);
    }
};

export const updateCustomerSession = (patch) => {
    const session = getCustomerSession();
    if (!session) {
        return;
    }

    saveCustomerSession({ ...session, ...patch });
};

export const clearCustomerSession = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
        console.log(err);
    }
};

// Fired by the axios interceptor when the refresh token is dead; App.js
// listens and clears the redux state.
export const SESSION_EXPIRED_EVENT = 'customer-session-expired';
